export const FORM_NAME = 'login'
export const CODE_ACCOUNT_LOCKED = '1018'
export const LOGIN_PROPERTY = 'login'
export const PASSWORD_PROPERTY = 'password'
export const REMEMBER_ME_PROPERTY = 'rememberMe'
